import electron from 'electron';

const getFocusedWindow = () => {
  return electron.remote.BrowserWindow.getFocusedWindow();
};

const getWebContents = () => {
  return getFocusedWindow()?.webContents;
};

export const electronUtils = {
  getFocusedWindow,
  getWebContents,
};
